<template>
    <div class="v-application--wrap grey lighten-4">
        <the-layout-drawer />
        <the-layout-toolbar />
        <the-layout-content/>

        <AVIChat
            v-if="$can('avi_login', 'AVIChat', 'avitoken')"
        />
        <the-layout-to-top-fab />
        <the-layout-footer />
        <PolicyAgreement :dialog="isProvider && !policyAgreement" :submit="submit" />
    </div>
</template>

<script>
import TheLayoutDrawer from './TheLayoutDrawer.vue'
import TheLayoutToolbar from './TheLayoutToolbar.vue'
import TheLayoutContent from './TheLayoutContent.vue'
// import TheLayoutFab from './TheLayoutFab.vue'
import AVIChat from '@/components/AVIChat.vue'
import TheLayoutToTopFab from './TheLayoutToTopFab.vue'
import TheLayoutFooter from './TheLayoutFooter.vue'
import PolicyAgreement from './PolicyAgreement.vue'

// UTILS
import { mapActions, mapGetters } from 'vuex'

const developmentMode = process.env.NODE_ENV === 'development'
export default {
  name: 'TheLayout',
  components: {
    TheLayoutDrawer,
    TheLayoutToolbar,
    TheLayoutContent,
    PolicyAgreement,
    TheLayoutToTopFab,
    AVIChat,
    TheLayoutFooter
  },
  data() {
    return {
      developmentMode
    }
  },
  computed: {
    ...mapGetters('account', ['policyAgreement', 'userGroup']),

    isProvider() {
      const { name = 'Proveedor' } = this.userGroup
      return ['Proveedor'].includes(name)
    }
  },
  methods: {
    ...mapActions('account', ['submitPolicyAgreement']),
    submit() {
      this.submitPolicyAgreement()
    }
  }
}
</script>

<style>
.v-navigation-drawer--fixed {
  -webkit-box-shadow: 0px 8px 10px -5px rgba(0, 0, 0, 0.2),
    0px 16px 24px 2px rgba(0, 0, 0, 0.14), 0px 6px 30px 5px rgba(0, 0, 0, 0.12);
  box-shadow: 0px 8px 10px -5px rgba(0, 0, 0, 0.2),
    0px 16px 24px 2px rgba(0, 0, 0, 0.14), 0px 6px 30px 5px rgba(0, 0, 0, 0.12);
}
</style>
